import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import queryString from 'query-string';

import { emailMFASelector, usuarioLogueadoSelector } from 'store/selectors';
import CardSpinner from 'components/CardSpinner';
import { CHANGE_USER_EMAIL_ROUTE } from 'constants/RouterConstants';
import {
  MFA_EMAIL_CARD_TITLE_TEXT,
  MFA_EMAIL_CARD_DESC_TEXT,
} from 'constants/commonConstants';
import { EmailVerifyCode, fetchMFA } from 'actions/mfa';
import Auth from 'utils/Auth';
import EmailMFACard from 'screens/email_configurar_2fa/EmailMFACard';

const ConfigurarEmail2FA = () => {
  const history = useHistory();
  const emailMFA = useSelector(emailMFASelector);
  const usuario = useSelector(usuarioLogueadoSelector);
  const dispatch = useDispatch();
  const [emailUuid, setEmailUuid] = useState(null);

  useEffect(() => {
    dispatch(fetchMFA(Auth.getInstance().getUserId()));
  }, []);

  useEffect(() => {
    const { uuid } = queryString.parse(history.location.search);
    if (uuid) setEmailUuid(uuid);
  }, [history]);

  const handleContinue = value => {
    dispatch(EmailVerifyCode(emailMFA.id, value, true, emailUuid));
  };

  const handleBack = e => {
    e.preventDefault();
    history.push(CHANGE_USER_EMAIL_ROUTE);
  };

  return (
    <div>
      {emailMFA ? (
        <EmailMFACard
          title={MFA_EMAIL_CARD_TITLE_TEXT}
          desc={MFA_EMAIL_CARD_DESC_TEXT(usuario?.user?.email)}
          handleContinue={handleContinue}
          handleBack={handleBack}
          uuid={emailUuid}
        />
      ) : (
        <CardSpinner spin />
      )}
    </div>
  );
};

export default ConfigurarEmail2FA;
